import { z } from 'zod';

export const ORDER_PRODUCT_COMPLETED_EVENT_TYPE: string = 'order.product.completed';

export const OrderProductCompletedEventPayloadSchema = z.strictObject({
    orderProductId: z.string().uuid(),
    positionProductId: z.string().uuid().nullable(),
    orderedQuantity: z.number().nonnegative(),
    fulfilledQuantity: z.number().nonnegative(),
});

export type OrderProductCompletedEventPayload = z.infer<typeof OrderProductCompletedEventPayloadSchema>;
